/* Conteúdo real portado de www.shoppub.com.br/plataforma (crawl 2026-09-20),
   polido para a nova linguagem. Os 7 capítulos são a espinha da página. */

export type Chapter = {
  id: string;
  n: string;
  short: string; // título curto (índice + rail)
  title: string;
  intro: string;
  bullets: string[];
  punch: string; // frase de fechamento (pull-quote)
  tone: "light" | "dark";
  mock?: "editorial" | "performance" | "conversao" | "dados" | "suporte" | "moda";
};

export const CHAPTERS: Chapter[] = [
  {
    id: "design",
    n: "001",
    short: "Design que veste",
    title: "Pensada para marcas que valorizam design e experiência",
    intro:
      "Enquanto outras plataformas tentam atender a todos, a Shoppub foi projetada especialmente para o universo da moda:",
    bullets: [
      "Layouts com design editorial e visual premium",
      "Interfaces que destacam produtos e histórias",
      "Personalização que respeita sua identidade de marca",
    ],
    punch: "Porque a moda não se vende por acaso — ela se vive e se reconhece.",
    tone: "light",
    mock: "editorial",
  },
  {
    id: "performance",
    n: "002",
    short: "Performance",
    title: "Performance que acompanha a ambição",
    intro:
      "Cada segundo no digital importa — especialmente na moda, onde o ritmo de consumo é acelerado. A Shoppub combina:",
    bullets: [
      "Carregamento rápido e estável",
      "Navegação fluida em todos os dispositivos",
      "Checkout simplificado e seguro",
      "Infraestrutura que acompanha picos de tráfego e campanhas",
    ],
    punch: "Mais que tecnologia — é performance que veste sua marca com velocidade e confiança.",
    tone: "dark",
    mock: "performance",
  },
  {
    id: "conversao",
    n: "003",
    short: "Conversão",
    title: "Conversão estratégica e experiência intuitiva",
    intro:
      "Tecnologia isolada não converte. É preciso confiança, fluidez e relevância em cada etapa da jornada:",
    bullets: [
      "Filtros inteligentes que ajudam o cliente a encontrar o que deseja",
      "Páginas de produto que contam a história da moda",
      "Carrinho e checkout pensados para reduzir abandono",
      "Visual que encoraja a compra — não apenas a navegação",
    ],
    punch: "Aqui, cada elemento da experiência é uma oportunidade de conversão.",
    tone: "light",
    mock: "conversao",
  },
  {
    id: "dados",
    n: "004",
    short: "Inteligência de dados",
    title: "Inteligência de dados para decisões reais",
    intro:
      "Ter dados não é o mesmo que saber o que fazer com eles. Com dashboards intuitivos e métricas relevantes, a Shoppub responde:",
    bullets: [
      "Quais produtos impulsionam as vendas?",
      "Onde estão as oportunidades de crescimento?",
      "O que priorizar na próxima campanha?",
    ],
    punch: "Dados estratégicos traduzidos em ações.",
    tone: "dark",
    mock: "dados",
  },
  {
    id: "integracoes",
    n: "005",
    short: "Integrações",
    title: "Conectividade e integrações inteligentes",
    intro:
      "A Shoppub potencializa a operação com integrações que realmente importam para a sua marca:",
    bullets: [
      "Ferramentas de remarketing e captação",
      "Integrações com mídias sociais",
      "Logística, pagamentos e experiência de loja",
      "Suporte para SEO avançado",
    ],
    punch: "Tudo conectado ao ecossistema que sua marca merece.",
    tone: "light",
  },
  {
    id: "parceria",
    n: "006",
    short: "Parceria contínua",
    title: "Suporte estratégico e parceria contínua",
    intro: "Aqui você não é apenas mais um cliente. Você tem ao seu lado:",
    bullets: [
      "Equipe de CS dedicada, acompanhando a evolução da sua loja",
      "Atendimento próximo e consultivo",
      "Onboarding estruturado",
      "Treinamentos e ferramentas para extrair o máximo da plataforma",
      "Foco em crescer no digital com autonomia e expertise",
    ],
    punch: "Do onboarding ao crescimento — gente de verdade, do seu lado.",
    tone: "dark",
    mock: "suporte",
  },
  {
    id: "moda",
    n: "007",
    short: "Feita para a moda",
    title: "Para quem moda é mais do que tendência",
    intro:
      "A Shoppub não atende moda por acaso. Atendemos marcas que sabem que tudo comunica — da vitrine ao último clique:",
    bullets: [
      "Onboarding estruturado e consultivo",
      "Suporte próximo e especializado",
      "Materiais, ferramentas e cases",
      "Comunidade de marcas que inspiram e crescem juntas",
    ],
    punch: "Porque moda carrega o seu design — e conecta pessoas a experiências.",
    tone: "light",
    mock: "moda",
  },
];
